import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

// Storage dummy pro SSR (RootComponent em routes/__root.tsx renderiza no
// servidor também, via Nitro — ver .output/server) — `window`/`localStorage`
// não existem lá. createSyncStoragePersister só PRECISA do objeto pra não
// quebrar o render; nada aqui é lido/escrito de verdade no servidor
// (persistClient/restoreClient só rodam dentro de efeitos client-side da
// própria lib).
const noopStorage: Storage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
  clear: () => {},
  key: () => null,
  length: 0,
};

// Pedido 2026-09-03: "eu dou F5 já aparece tudo carregado igual" — cache do
// React Query (identity/permissões/avatar/perfil/faturas/documentos/fotos
// de veículo etc.) sobrevive ao F5 via localStorage. Módulo próprio (em vez
// de definido dentro de __root.tsx) porque auth-context.tsx também precisa
// dele: no logout/troca de sessão, além de queryClient.clear() (memória),
// isto some da persistência em disco também — sem isso, um CPF/fatura/
// documento do cliente anterior ficaria salvo no localStorage do
// navegador/computador compartilhado até o próximo F5 sobrescrever
// (ver clearSession em auth-context.tsx).
export const gpsDrivePersister = createSyncStoragePersister({
  storage: typeof window !== "undefined" ? window.localStorage : noopStorage,
  key: "gpsdrive-query-cache",
});
